module.exports = __webpack_public_path__ + "img/platform_icon.2e30157c.svg";